// Configuration de l'exploitation agricole.
// Modifiez ces valeurs pour adapter l'outil à votre exploitation.

export const FARM_CONFIG = {
  name: "Mon Exploitation",
  // Centre par défaut (utilisé si l'utilisateur n'a pas encore de parcelles)
  center: [49.04134, 1.9724],
  // Niveaux de zoom autorisés
  minZoom: 6,
  maxZoom: 18,
  defaultZoom: 13,
  // Marge (degrés) ajoutée autour des parcelles pour borner le déplacement
  fitPadding: 0.05,
};

// Bornes larges (France métropolitaine) tant qu'aucune parcelle n'est chargée.
export function getMaxBounds() {
  return [
    [41.0, -5.6],
    [51.6, 9.9],
  ];
}
